import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import useTableScroll from './hooks/useTableScroll/useTableScroll'
import ParcelRow from './ParcelRow/ParcelRow'
import TableHorizontalScrollArrows from './TableHorizontalScrollArrows/TableHorizontalScrollArrows'
import { headers } from './constants'
import * as Styles from './styles'

const ParcelsTable = ({
  parcels,
  onSelect,
  selectedParcels,
  getParcelDetailHref,
  onParcelDetailClick,
  parcelDetailSelectedId,
}) => {
  const { t } = useTranslation()
  const { tableContainerRef, moveScroll, showLeftArrow, showRightArrow } = useTableScroll()

  const isSelected = id => selectedParcels?.map(parcel => parcel.id).includes(id)

  return (
    <Styles.MainContainer data-testid="parcels-table">
      <TableHorizontalScrollArrows
        onClickInArrow={moveScroll}
        showLeftArrow={showLeftArrow}
        showRightArrow={showRightArrow}
      />
      <Styles.TableContainer ref={tableContainerRef}>
        <Styles.Table>
          <Styles.TableHeader>
            {headers.map(header => (
              <Styles.HeaderCell key={header.id}>
                {header?.label && <Text type="titleS">{t(header.label)}</Text>}
              </Styles.HeaderCell>
            ))}
          </Styles.TableHeader>
          <Styles.TableBody>
            {parcels?.results?.map(parcel => (
              <ParcelRow
                key={parcel.id}
                parcel={parcel}
                onSelect={() => onSelect(parcel.id)}
                selected={isSelected(parcel.id)}
                getParcelDetailHref={getParcelDetailHref}
                onParcelDetailClick={onParcelDetailClick}
                parcelDetailSelectedId={parcelDetailSelectedId}
              />
            ))}
          </Styles.TableBody>
        </Styles.Table>
      </Styles.TableContainer>
    </Styles.MainContainer>
  )
}

export default ParcelsTable
